import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              <i className="ri-folder-open-line text-primary-500 mr-2"></i>
              专题索引
            </h2>
            <p className="text-foreground-500 text-sm">按分类浏览所有吃瓜专题内容</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {indexItems.map((item, idx) => (
              <a
                key={idx}
                href="#topics"
                className="group flex items-center gap-4 p-4 md:p-5 bg-background-100 hover:bg-background-200 rounded-xl transition-colors cursor-pointer no-underline"
              >
                <span className="w-12 h-12 flex items-center justify-center bg-primary-100 text-primary-500 rounded-xl text-xl flex-shrink-0 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className={item.icon}></i>
                </span>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-500">{item.count}</span>
                </div>
                <span className="text-foreground-400 group-hover:text-primary-400 transition-colors">
                  <i className="ri-arrow-right-s-line text-lg"></i>
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}